<!--
 * @FileDescription: 申请退款页面
 * @Author: 陈文景
 * @Date: 2022-11-11 10:08:10
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <h3 class="rufund">Rufund Order</h3>

    <div v-if="other.refunded === 1" class="record">
      <span class="text">Order has been refunded before</span>
      <el-button :disabled="!unshippeds.length" class="record-button" round @click="showRefundRecord">Refund Record</el-button>
    </div>

    <div v-loading="detailsLoading" class="details">
      <div class="left">
        <!-- 未发货 -->
        <template v-if="unshippeds.length">
          <NotShippedGoods :data="unshippeds" :refundData="refundData" @change="handleSelectAll" @amount="getCheckedAmountItem" />
        </template>

        <!-- 空状态 -->
        <template v-else>
          <div class="not-data">
            <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
            <span class="tips-text">{{ noRecord }}</span>
          </div>
        </template>
      </div>

      <div class="right">
        <div class="reason">
          <h3 class="title">Refund Notes</h3>
          <el-form :model="form" :rules="rules" ref="form" :label-width="`${labelWidth}px`">
            <el-form-item label="Refund Reason" prop="refundReason">
              <el-select v-model="form.refundReason" :disabled="!unshippeds.length" size="medium" placeholder="Input Content">
                <el-option v-for="item in cancelReasonOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-input v-model="form.remark" :disabled="!unshippeds.length" type="textarea" maxlength="120" show-word-limit :rows="5" resize="none" placeholder="Remarks" />
        </div>

        <div v-loading="amountLoading">
          <div class="amount-info">
            <h3 class="title">Refunded Amount</h3>
            <p>
              <span>Subtotal</span>
              <span class="money">US ${{ amountTips(other.itemSubtotal) }}</span>
            </p>
            <p>
              <span>Shipping Fee</span>
              <span class="money">US ${{ amountTips(other.shippingSubtotal) }}</span>
            </p>
            <p>
              <span>Promo code</span>
              <span class="money">- US ${{ amountTips(other.promotion) }}</span>
            </p>
            <p>
              <span>Coupon</span>
              <span class="money">- US ${{ amountTips(other.coupon) }}</span>
            </p>
          </div>

          <div class="refund-info">
            <div>
              <p>
                <span>Total refunded amount</span>
                <span>$ <el-input-number v-model="form.refundAmount" :disabled="!unshippeds.length" size="mini" controls-position="right" :min="0" :max="other.orderMaximumRefund" /> </span>
              </p>
              <p class="size">
                <span>Maximum refund</span>
                <span class="money">US ${{ amountTips(other.orderMaximumRefund) }}</span>
              </p>
            </div>
            <div class="button">
              <el-button :disabled="!unshippeds.length" type="primary" @click="submitApplicationForRefund">Refund</el-button>

              <el-checkbox v-model="form.isNotice" :disabled="!unshippeds.length" :false-label="0" :true-label="1">邮件通知客户</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款记录对话框 -->
    <RefundRecordDialog ref="refundRecordDialog" />

    <!-- 退款失败提示对话框 -->
    <RefundFaliDialog ref="refundFaliDialog" />
  </div>
</template>

<script>
import API from '@/api'
import NotShippedGoods from './NotShippedGoods.vue'
import RefundFaliDialog from './RefundFaliDialog.vue'
import RefundRecordDialog from './RefundRecordDialog.vue'

let form = {
  packItems: [
    // {
    //   kkItemId: undefined, // 商品ID
    //   skuCode: undefined, // 公司SKU
    //   productNum: undefined, // 商品数量
    //   packId: undefined // 包裹ID(未发货包裹不需要传)
    // }
  ], // 已发货
  refundReason: undefined, // 退款原因
  remark: undefined, // 备注
  refundAmount: 0, // 退款文本框(金额格式)
  isNotice: 0, // 0.不通知 1.通知 (是否邮箱通知客户)
  selectAllied: undefined // 针对未发货包裹 - 是否全选(0.未全选 1.全选)
}

let getAmountQuery = {
  items: [
    // {
    //   kkItemId: undefined,
    //   skuCode: undefined,
    //   productNum: 0
    // }
  ]
}

export default {
  components: {
    NotShippedGoods,
    RefundFaliDialog,
    RefundRecordDialog
  },
  data() {
    return {
      refundData: {}, // 退款数据
      labelWidth: 132, // 表单Label宽度

      detailsLoading: false,
      amountLoading: false,

      form: { ...form }, // 创建售后单请求参数

      getAmountQuery: { ...getAmountQuery }, // 获取退款金额请求参数

      rules: {
        refundReason: [{ required: true, message: 'Please select a refund reason.', trigger: 'change' }]
      },

      // 取消原因下拉选项
      cancelReasonOptions: [
        { label: 'Out Of Stock', value: 3 },
        { label: 'Shipment Delay', value: 4 },
        { label: "Don't Want Anymore", value: 0 },
        { label: 'Incorrect Address Information', value: 2 },
        { label: 'Product Selection Error/Multiple Selection', value: 1 },
        { label: 'Other', value: 5 }
      ],

      // Refunded Amount
      other: {
        refunded: 0, // 是否有退款记录(0.没有退款记录 1.有退款记录)
        orderMaximumRefund: 0, // 最大退款金额
        itemSubtotal: 0, // Item Subtotal
        shippingSubtotal: 0, // Shipping Subtotal
        promotion: 0, // Promo code
        coupon: 0 // Coupon
      },

      // 未发货商品
      unshippeds: [
        // {
        //   id: 1,
        //   imageUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
        //   productName: "NC Women's Satin Silk Pajama Set2Pie",
        //   productNum: 1,
        //   skuCode: 'AMB00393_1',
        //   sellerSku: 'AMB00123456',
        //   options: 'Black、XL',
        //   price: 50,
        //   refundableAmount: 50,
        //   kkItemId: '12355',
        //   check: false, // 是否选中
        //   quantity: 0 // 退款商品数量
        // },
        // {
        //   id: 2,
        //   imageUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
        //   productName: "NC Women's Satin Silk Pajama Set2Pie",
        //   productNum: 2,
        //   skuCode: 'AMB00393_2',
        //   sellerSku: 'AMB00123456',
        //   options: 'Black、XL',
        //   price: 50,
        //   refundableAmount: 50,
        //   kkItemId: '12355',
        //   check: false, // 是否选中
        //   quantity: 0 // 退款商品数量
        // },
        // {
        //   id: 3,
        //   imageUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
        //   productName: "NC Women's Satin Silk Pajama Set2Pie",
        //   productNum: 3,
        //   skuCode: 'AMB00393_3',
        //   sellerSku: 'AMB00123456',
        //   options: 'Black、XL',
        //   price: 50,
        //   refundableAmount: 50,
        //   kkItemId: '12355',
        //   check: false, // 是否选中
        //   quantity: 0 // 退款商品数量
        // }
      ],

      noRecord: undefined // 无数据展示文案
    }
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    }
  },
  created() {
    this.getRefundOrderInformation()
  },
  methods: {
    /**
     * API 获取可申请退款商品列表
     */
    async getRefundOrderInformation() {
      try {
        this.detailsLoading = true
        let { data, message } = await API.getRefundOrderInformation(this.$route.query.kakaOrderId)
        if (data) {
          this.refundData = data
          this.noRecord = 'No Record'
          this.other.refunded = data.refunded // 是否有退款记录(0.没有退款记录 1.有退款记录)
          this.other.orderMaximumRefund = data.orderMaximumRefund // 最大退款金额
          this.unshippeds = this.reformUnshippeds(data.items || []) // 未发货
        } else {
          this.noRecord = message
        }
        this.detailsLoading = false
      } catch (error) {
        this.detailsLoading = false
        throw new Error(error.message)
      }
    },

    /**
     * API 创建售后单
     */
    async createAfterSalesOrder() {
      try {
        let { code, data } = await API.createAfterSalesOrder(this.$route.query.kakaOrderId, this.form)
        if (code === 10000) {
          this.$router.push(`/orders/all-orders/order-success?returnsId=${data}`)
        } else {
          this.$refs.refundFaliDialog.show()
        }
      } catch (error) {
        this.$refs.refundFaliDialog.show()
      }
    },

    /**
     * API 获取退款金额
     */
    async getRefundOrderAmount() {
      try {
        this.amountLoading = true
        let { data, code, message } = await API.getRefundOrderAmount(this.$route.query.kakaOrderId, this.getAmountQuery)
        if (code !== 10000) this.$message.error(message)
        this.other.itemSubtotal = data.skusAmount
        this.other.shippingSubtotal = data.freightAmount
        this.other.promotion = data.promotionAmount // 优惠码金额
        this.other.coupon = data.couponTicketAmount // 优惠券金额
        this.form.refundAmount = data.totalAmount // 退款金额总数
        this.amountLoading = false
      } catch (error) {
        this.amountLoading = false
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} unshippeds 未发货列表
     * @returns {Array} 改造后的数据
     */
    reformUnshippeds(unshippeds) {
      if (unshippeds.length) {
        return unshippeds.map((item) => ({
          ...item,
          options:
            JSON.parse(item.options) &&
            JSON.parse(item.options)
              .map((option) => JSON.parse(option).value)
              .join('、'),
          check: false, // 是否选中
          quantity: 0 // 退款商品数量
        }))
      } else {
        return unshippeds
      }
    },

    /**
     * 获取需要计算退款金额的商品
     */
    getCheckedAmountItem() {
      this.getAmountQuery.items = []
      // 未发货
      this.unshippeds.forEach((item) => {
        if (item.check) {
          this.getAmountQuery.items.push({
            kkItemId: item.kkItemId, // 商品ID
            skuCode: item.skuCode, // 公司SKU
            productNum: item.quantity, // 商品数量
            countryCode: item.countryCode
          })
        }
      })
      // 调用获取退款金额的接口
      this.getRefundOrderAmount()
    },

    /**
     * 显示退款记录对话框
     */
    showRefundRecord() {
      this.$refs.refundRecordDialog.show(this.$route.query.kakaOrderId)
    },

    /**
     * 选中所有
     *
     * @param {Boolean} value 是否选中
     * @param {Number} type 1.已发货 2.未发货
     * @param {String} packId 包裹ID（操作已发货的包裹时则存在）
     */
    handleSelectAll(value, type, packId) {
      if (type === 2) {
        this.unshippeds.forEach((item) => {
          item.check = value
          item.quantity = value ? item.productNum : 0
        })
      }
      this.getCheckedAmountItem()
    },

    /**
     * 发起申请退款
     */
    submitApplicationForRefund() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.packItems = []
          // 未发货
          this.unshippeds.forEach((item) => {
            if (item.check) {
              this.form.packItems.push({
                kkItemId: item.kkItemId, // 商品ID
                skuCode: item.skuCode, // 公司SKU
                productNum: item.quantity, // 商品数量
                packId: undefined, // 包裹ID(未发货包裹不需要传)
                countryCode: item.countryCode
              })
            }
          })
          if (this.form.packItems.length) {
            this.getIsSelectAll()
            this.createAfterSalesOrder() // 发起请求
          } else {
            this.$message.warning('Please select the product to be refunded!')
          }
        } else {
          return false
        }
      })
    },

    /**
     * 判断是否已经是全选
     * 为了设置this.form.selectAllied参数(是否全选(0.未全选 1.全选))
     * 计算方式：item.quantity === item.productNum 则全选
     */
    getIsSelectAll() {
      this.form.selectAllied = 1
      this.unshippeds.forEach((item) => {
        if (item.quantity !== item.productNum) {
          this.form.selectAllied = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1187px;
  min-width: 1187px;
  margin: 0 auto;

  .rufund {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .record {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
    .text {
      color: #eb5757;
      font-size: 18px;
      font-weight: 500;
    }
    .record-button {
      width: 150px;
      height: 44px;
      border-radius: 22px;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;
    .left {
      width: 812px;
      .not-data {
        display: flex;
        height: 100%;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        .tips-text {
          color: #747a87;
          font-size: 16px;
          margin-top: 28px;
        }
      }
    }
    .right {
      width: 355px;
      .title {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 20px;
      }
      .reason {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        background-color: #fff;
        .el-form {
          width: 100%;
          .el-form-item {
            .el-select {
              width: 100%;
              /deep/ .el-input__suffix {
                height: 36px;
              }
            }
          }
        }
      }

      .amount-info {
        padding: 15px;
        background-color: #fff;
        border-bottom: 1px solid #f5f7f7;
        .title {
          font-size: 18px;
          font-weight: 500;
        }
        p {
          display: flex;
          color: #747a87;
          font-size: 14px;
          font-weight: 500;
          margin-top: 20px;
          justify-content: space-between;
          .money {
            color: #10141d;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      .refund-info {
        padding: 12px;
        background-color: #fff;
        p {
          display: flex;
          align-items: center;
          justify-content: space-between;
          &.size {
            color: #747a87;
            font-size: 14px;
            margin: 15px 0;
          }
          .el-input-number {
            width: 100px;
          }
          .money {
            color: #eb5757;
          }
        }
        .button {
          text-align: center;
          .el-button {
            width: 100%;
          }
          .el-checkbox {
            margin-top: 12px;
          }
        }
      }
    }
  }
}
</style>
